/**
 * Landing page Radar: caroselli screenshot (Company, VistaGare AI) + lightbox su immagini.
 * Eseguito solo se esiste `.vg-landing` (template page-vistagare-radar).
 */
(function () {
    'use strict';

    function initScreenshotSlider(slider) {
        var slides = slider.querySelectorAll('.vg-landing__company-slide');
        if (!slides.length) return;
        var i = 0;
        var ms = parseInt(slider.getAttribute('data-landing-interval') || '3000', 10);
        if (ms < 1500) ms = 3000;
        var timer = null;

        slider.setAttribute('tabindex', '0');

        function setActive(next, announce) {
            slides[i].classList.remove('is-active');
            slides[i].setAttribute('aria-hidden', 'true');
            i = next;
            slides[i].classList.add('is-active');
            slides[i].setAttribute('aria-hidden', 'false');
            if (announce) {
                var img = slides[i].querySelector('img');
                var live = slider.querySelector('[data-landing-live]');
                if (!live) {
                    live = document.createElement('div');
                    live.setAttribute('data-landing-live', '');
                    live.className = 'vg-visually-hidden';
                    live.setAttribute('aria-live', 'polite');
                    live.setAttribute('aria-atomic', 'true');
                    slider.appendChild(live);
                }
                live.textContent = img && img.alt ? img.alt : 'Slide ' + (i + 1);
            }
        }

        function restartTimer() {
            if (timer) clearInterval(timer);
            timer = setInterval(function () {
                setActive((i + 1) % slides.length, false);
            }, ms);
        }

        slider.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'Right') {
                e.preventDefault();
                setActive((i + 1) % slides.length, true);
                restartTimer();
            } else if (e.key === 'ArrowLeft' || e.key === 'Left') {
                e.preventDefault();
                setActive((i - 1 + slides.length) % slides.length, true);
                restartTimer();
            }
        });

        restartTimer();
    }

    function initScreenshotSliders(root) {
        var sliders = root.querySelectorAll('[data-landing-screenshot-slider]');
        for (var s = 0; s < sliders.length; s++) {
            initScreenshotSlider(sliders[s]);
        }
    }

    function ensureLightbox() {
        var el = document.getElementById('vg-landing-lightbox');
        if (el) return el;

        el = document.createElement('div');
        el.id = 'vg-landing-lightbox';
        el.className = 'vg-landing-lightbox';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.setAttribute('aria-label', 'Immagine ingrandita');
        el.innerHTML =
            '<button type="button" class="vg-landing-lightbox__backdrop" aria-label="Chiudi"></button>' +
            '<div class="vg-landing-lightbox__panel">' +
            '<button type="button" class="vg-landing-lightbox__close" aria-label="Chiudi">&times;</button>' +
            '<div class="vg-landing-lightbox__stage"><img src="" alt="" /></div>' +
            '</div>';

        document.body.appendChild(el);

        var img = el.querySelector('.vg-landing-lightbox__stage img');
        var closeBtn = el.querySelector('.vg-landing-lightbox__close');
        var backdrop = el.querySelector('.vg-landing-lightbox__backdrop');

        function close() {
            el.classList.remove('is-open');
            document.body.classList.remove('vg-landing-lightbox-open');
            if (img) img.removeAttribute('src');
        }

        function onKey(ev) {
            if (ev.key === 'Escape' && el.classList.contains('is-open')) {
                close();
            }
        }

        closeBtn.addEventListener('click', close);
        backdrop.addEventListener('click', close);
        document.addEventListener('keydown', onKey);

        return el;
    }

    function openLightbox(src, alt) {
        if (!src) return;
        var el = ensureLightbox();
        var img = el.querySelector('.vg-landing-lightbox__stage img');
        if (!img) return;
        img.src = src;
        img.alt = alt || '';
        el.classList.add('is-open');
        document.body.classList.add('vg-landing-lightbox-open');
    }

    function initLandingLightbox(root) {
        root.addEventListener(
            'click',
            function (ev) {
                var t = ev.target;
                if (!t || t.tagName !== 'IMG') return;
                if (t.closest('a[href]')) return;
                var src = t.currentSrc || t.getAttribute('src');
                if (!src) return;
                openLightbox(src, t.getAttribute('alt') || '');
            },
            false
        );
    }

    function boot() {
        var root = document.querySelector('.vg-landing');
        if (!root) return;
        initScreenshotSliders(root);
        initLandingLightbox(root);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
